import { render, staticRenderFns } from "./BookInfo.vue?vue&type=template&id=61315f68&scoped=true"
import script from "./BookInfo.vue?vue&type=script&lang=js"
export * from "./BookInfo.vue?vue&type=script&lang=js"
import style0 from "./BookInfo.vue?vue&type=style&index=0&id=61315f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61315f68",
  null
  
)

export default component.exports